// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/ats-unit-callsigns.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/ats-unit-callsigns/ats-unit-callsigns.js';

mount([g0]);
